import { render, staticRenderFns } from "./InsuranceSurgeryDetails.vue?vue&type=template&id=25277d8c"
import script from "./InsuranceSurgeryDetails.vue?vue&type=script&lang=js"
export * from "./InsuranceSurgeryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports